import React from 'react';
import { Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import EditIcon from '@mui/icons-material/Edit';
import { numberToCurrencyFormat } from '../../../utils/numberToCurrencyFormat';
import { useTranslation } from 'react-i18next';

export default function InvoicePaymentView({handleEdit, open, onClose, payment = null, invoice = null}) { 
    const { t } = useTranslation('common'); 
    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(payment);
    };

    if (!payment) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Payment</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Patient</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${invoice.pet.name} (${invoice.owner.last_name}, ${invoice.owner.first_name})`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Date</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{payment.date}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Amount Paid</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{numberToCurrencyFormat(payment.amount_paid)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Payment Method</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{payment.paymentMethod.name}</Typography>
                
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Status</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{payment.status}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Remarks</Typography>
                <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{payment.remarks || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(payment.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(payment.updatedAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>User</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{payment.user.name}</Typography>

            </DialogContent>
            <DialogActions>
              <div style={{flex: '1 0 0'}} />
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}